export default __webpack_public_path__ + "static/media/RepubblicaVenerdì(1)-2-3.8ae1d505.pdf";